if (!window.ssOfferGuideReady) {
  window.ssOfferGuideReady = true;
  document.addEventListener('click', function(event) {
    const link = event.target.closest('[data-ss-offer-clara]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    if (window.fonio?.webchat?.open) {
      event.preventDefault();
      try { window.fonio.webchat.open(); } catch { window.location.assign(link.href); }
    }
  });
}
